import clockIcon from "../assests/HPE/enterpriseone/ent-a/icons/clock.svg";
import arrowRightIcon from "../assests/HPE/enterpriseone/ent-a/icons/arrow-right.svg";
import userIcon from "../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import number1 from "../assests/HPE/enterpriseone/ent-b/numbers-1.svg";
import number2 from "../assests/HPE/enterpriseone/ent-b/numbers-2.svg";
import number3 from "../assests/HPE/enterpriseone/ent-b/numbers-3.svg";
import masterHead from "../assests/HPE/enterpriseone/ent-b/png/masthead-ent-b.png";

import HilightCard from "../components/ui/enterprise1/HilightCard";
import benefitCard1 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-1.webp";
import benefitCard2 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-2.webp";
import StatsCard from "../components/ui/enterprise1/StatsCard";
import EnterpriseInput from "../components/ui/enterprise1/EnterpriseInput";
import { useState } from "react";
import ResourcesFrom from "../components/ui/enterprise1/ResourcesForm";
import EnterpriseHeader from "../components/ui/enterprise1/EnterpriseHeader";
import DocumentForm from "../components/ui/enterprise1/DownloadForm";
import StackedDocuments from "../components/ui/enterprise1/StackedDocuments";
import EnterpriseFooter from "../components/ui/enterprise1/EnterpriseFooter";
import Layout from "../components/layout/Layout";
import { useTrackEvent } from "../hooks/useTrackEvent";
const EnterpriseTwo = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const trackEvent = useTrackEvent();

  const handleFullNameFocus = () => {
    trackEvent(
      {
        event: "form_start",
        form_location: "hero",
        statsig_design_id: "hybrid-2",
      },
      { once: true },
    );
  };

  function handleOpenPopup() {
    if (!fullName.trim()) {
      setFullNameError(true);
      return;
    }
    setFullNameError(false);
    setShowPopup(true);
    trackEvent(
      {
        event: "form_continue",
        form_location: "hero",
        statsig_design_id: "hybrid-2",
      },
      { once: true },
    );
  }
  return (
    <Layout title="HPE Hybrid Cloud" variant="enterprise">
      <div className="w-full ">
        {/* <div className="w-full bg-navy-blue-01  pt-5 md:pb-16 pb-4 flex justify-center">
        <EnterpriseHeader />
      </div> */}
        {/** 1 */}
        <div className="w-full bg-navy-blue-01 pb-[96px]">
          <div className="flex flex-col max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto md:flex-row gap-6 md:gap-10 ">
            {/* LEFT SECTION */}
            <div className="flex flex-col gap-10 md:gap-16 w-full lg:w-1/2 lg:min-w-[450px]">
              {/* TEXT (TOP) */}
              <div className="order-1 md:order-none flex flex-col gap-6 md:max-w-[450px]">
                <p className=" text-grey-02 font-medium text-[22px]/[28px] font-google md:text-[36px]/[44px] self-stretch">
                  <span className="text-blue">97% less</span> alert noise.
                  <span className="text-blue"> 150x faster</span> provisioning.
                  Up to
                  <span className="text-blue"> 90% lower </span> VMware costs.
                </p>

                <p className="text-grey-04 md:text-4/6 text-3/[18px] font-inter">
                  Three specific outcomes. Three HPE products. One platform that
                  sits on top of what you already have.
                </p>
              </div>

              {/* IMAGE (MOBILE ONLY - BETWEEN) */}
              <div className="order-2 md:hidden w-full flex">
                <div className="relative w-full md:max-w-[553px]">
                  <img
                    src={masterHead}
                    alt=""
                    className="w-full h-auto rounded-[8px]"
                  />
                </div>
              </div>

              {/* FORM (BOTTOM) */}
              <div className="order-3 md:order-none flex w-full md:min-w-[400px] md:max-w-[400px] flex-col gap-6">
                {/* STEP */}
                <span className="text-white py-0.5 px-3 rounded-3xl bg-navy-blue-03 w-fit text-2/[22px] font-google font-medium">
                  STEP 1 / 2
                </span>

                {/* INPUT */}
                <div className="flex flex-col gap-4">
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col gap-1">
                      <EnterpriseInput
                        placeholder="Full name*"
                        variant="dark"
                        className="flex-1"
                        icon={userIcon}
                        inputClassName="text-white text-[14px]/[22px] font-medium h-[46px]"
                        iconClassName="w-5 h-5"
                        value={fullName}
                        onFocus={handleFullNameFocus}
                        onChange={(e) => {
                          setFullName(e.target.value);
                          if (e.target.value.trim()) {
                            setFullNameError(false);
                          }
                        }}
                        error={
                          fullNameError ? "Please enter your full name" : ""
                        }
                      />
                    </div>

                    <div
                      onClick={handleOpenPopup}
                      className="flex h-[46px] px-4 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 items-center justify-center cursor-pointer"
                    >
                      <img
                        src={arrowRightIcon}
                        className="w-[18px] h-[18px]"
                        alt=""
                      />
                    </div>
                  </div>

                  {/* INFO */}
                  <div className="flex items-center gap-2">
                    <img src={clockIcon} className="w-[14px] h-[14px]" alt="" />
                    <p className="text-grey-03 font-normal text-[10px]/[18px] md:text-[12px]/[20px] font-inter">
                      <span className="text-green font-medium">
                        Takes 30 seconds.
                      </span>{" "}
                      Resource pack downloads instantly after.
                    </p>
                  </div>
                </div>

                {/* DIVIDER */}
                <div className="w-full h-[1px] border-white/10 border-dashed border-t" />

                {/* ZIP CARD */}
                <StackedDocuments />
              </div>
            </div>

            {/* RIGHT IMAGE (DESKTOP ONLY) */}
            <div className="hidden md:flex w-full md:w-[553px] justify-end">
              <div className="relative w-full max-w-[553px]">
                <img
                  src={masterHead}
                  alt=""
                  className="w-full h-auto rounded-[8px]"
                />
              </div>
            </div>
          </div>
        </div>
        {/** 2 */}

        <div className="w-full bg-navy-blue-02">
          <div
            className="
                flex flex-col md:flex-row max-w-[1188px] mx-auto
                py-12 md:py-20
                px-4 sm:px-6 md:px-10
                gap-6 md:gap-10
                items-start md:items-center
                bg-navy-blue-02 "
          >
            <StatsCard
              title="88%"
              description="Of enterprise IT environments are hybrid today"
              image={number1}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="$6M"
              description="Saved by AstraZeneca with HPE Morpheus"
              image={number2}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="32%"
              description="Of organisations evaluating VMware alternatives"
              image={number3}
            />
          </div>
        </div>
        {/** 3 */}
        {/* <div className="flex flex-col justify-center items-center container mx-auto w-full gap-[80px] mt-[120px]  m-auto mb-[80px]"> */}
        <div className="w-full max-w-[1188px] mx-auto md:mt-[120px] mt-20 mb-[80px] flex flex-col gap-[80px] px-4 sm:px-6 md:px-10">
          <div className="font-inter">
            <p className="text-grey-06 text-[20px] leading-[32px] text-start md:text-[32px] font-style:normal md:leading-[48px] font-medium font-google">
              Broadcom VMware pricing has
              <span className="text-red"> increased 30 to 1200% </span> for most
              enterprise customers. Manual alert triage is consuming IT ops
              capacity.
              <span className="text-red">
                {" "}
                Provisioning still takes days
              </span>{" "}
              when it should take minutes. These are three separate problems
              with
              <span className="text-blue-500"> one practical solution.</span>
            </p>
          </div>
          <div className="flex flex-col items-start gap-12 md:inline-flex md:w-auto md:flex-row md:items-center md:gap-6">
            <HilightCard
              badge="MORPHEUS VM ESSENTIALS"
              image={benefitCard1}
              title="Stop paying VMware tax"
              description="Run VMware and KVM side by side on existing infrastructure. No forced migration. Per-socket pricing at a fraction of Broadcom charges."
            />
            <HilightCard
              badge="OPSRAMP"
              image={benefitCard2}
              title="Stop firefighting, start preventing"
              description="AI alert correlation across cloud and on-prem. Automated remediation. MTTR drops from hours to minutes."
            />
          </div>
          <div className="w-full">
            <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">
              {/* CONTENT */}
              <div className="order-2 md:order-1 w-full md:flex-1 bg-softGray p-6 md:p-10 flex flex-col justify-between gap-6 md:gap-10">
                {/* TOP */}
                <div className="flex flex-col gap-5 md:gap-8">
                  <p className="inline-flex px-3 py-1 font-google rounded-3xl bg-navy-blue-03 text-white text-[10px] md:text-[12px] font-medium w-fit">
                    CUSTOMER SPEAK
                  </p>

                  <div className="flex flex-col gap-2 md:gap-4">
                    <p className="text-grey-09 text-[20px] leading-[32px] font-google font-medium md:text-[32px] md:leading-[48px]">
                      "HPE Morpheus VM Essentials provides a real alternative to
                      the status quo. With support for my existing hypervisor
                      and a flexible path for future workloads, we can modernize
                      our business for operational and resource efficiency."
                    </p>
                    <p className="text-grey-05 text-[18px] leading-[26px] font-inter md:text-[20px] md:leading-[28px] font-medium">
                      Chris Macken, Vice President IT Operations and Security,
                      Cambrian Credit Union
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/** 4 */}
        <ResourcesFrom
          showPreview={true}
          isPopup={false}
          showCurrentChallenge={false}
          showEnterpriseTwoSelects={true}
          buttonText="Get instant access"
          formLocation="bottom"
          statsigDesignId="hybrid-2"
        />
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black/80"
              onClick={() => setShowPopup(false)}
            />

            <div className="relative w-full max-w-[1100px] z-10 max-h-[90vh] overflow-y-auto">
              <ResourcesFrom
                showPreview={true}
                isPopup={true}
                onClose={() => setShowPopup(false)}
                initialFullName={fullName}
                showCurrentChallenge={false}
                showEnterpriseTwoSelects={true}
                buttonText="Get instant access"
                formLocation="hero"
                statsigDesignId="hybrid-2"
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default EnterpriseTwo;
